<template>
  <div id="app" @keydown="Tab($event)">
    <Loading v-if="$store.state.loading"></Loading>
    <PWAPrompt />
    <router-view />
  </div>
</template>
<script>
import moment from 'moment-jalaali'
import PWAPrompt from './PWAPrompt.vue'
import Loading from '@/components/Loading/Loading.vue'

export default {
  data() {
    return {
      dots: null,
    }
  },
  methods: {
    Tab(event) {
      if (event.keyCode == 13) {
        var self = event.target
        if ('TEXTAREA' != self.tagName) {
          event.preventDefault()
          var all = document.querySelectorAll('input, select, a , button, Textarea')
          if (['A', 'BUTTON'].includes(self.tagName)) {
            self.click()
          } else {
            var array = []
            all.forEach((element) => {
              if (element.getAttribute('tabindex') != -1 && !element.hidden && !element.disabled) {
                array.push(element)
              }
            })
            var place = array.indexOf(self)
            // console.log(array[place]);
            array[place + 1].focus()
            if (event.target.id == 'PassWord') {
              array[place + 1].click()
            }
          }
        }
      }
    },
    GetAlarm() {
      if (this.dots) return
      const dots = setInterval(() => {
        var UserAlarm = JSON.parse(this.$cookies.get('UserAlarm'))
        var datetime = moment().format('jYYYY/jMM/jDD') + ' ' + moment().format('HH:mm')
        var vueThis = this
        if (UserAlarm != null && UserAlarm.length > 0) {
          for (let index = 0; index < UserAlarm.length; index++) {
            if (UserAlarm[index].DateAlarm.trim() <= datetime && UserAlarm[index].IsView == false) {
              const notification = {
                title: 'یادآوری',
                options: {
                  body: UserAlarm[index].AlarmText,
                  icon: 'https://bnpco.ir/favicon.ico',
                },
                events: {
                  onclick: function () {
                    if (vueThis.$route.name != 'Alarm') {
                      vueThis.$router.push({
                        name: 'Alarm',
                      })
                    }
                  },
                },
              }
              this.$notification.show(notification.title, notification.options, notification.events)
            }
          }
        }
      }, 60000)
      this.dots = dots
    },
    updated() {
      this.$store.state.JalaliDate = moment().format('jYYYY/jMM/jDD')
      this.$store.state.JalaliTime = moment().format('HH:mm')
    },
  },
  mounted() {
    this.$GetAppsettings()
    this.$store.state.JalaliDate = moment().format('jYYYY/jMM/jDD')
    this.$store.state.JalaliTime = moment().format('HH:mm')
    if (this.URL != '') {
      this.$cookies.set('URL', this.URL)
    }
  },
  created() {
    this.$store.commit('myVersionSoftware', '1.2.0122')
    this.$store.commit('myJalaliDate', moment().format('jYYYY/jMM/jDD'))
    this.$store.commit('myJalaliTime', moment().format('HH:mm'))
    this.$GetAppsettings()
    this.GetAlarm()
  },
  beforeDestroy() {
    clearInterval(this.dots)
  },
  watch: {
    $route(to, from) {
      if (to.name != 'PrintTempFactor') {
        document.getElementsByTagName('title')[0].innerHTML = this.$store.state.title
      }
      this.$store.state.Modal = false
    },
  },
  components: { PWAPrompt, Loading },
}
</script>

<style src="./styles/theme.scss" lang="scss" />
<style>
#app {
  background: #fff !important;
}
@import url('./assets/FA/css/all.min.css');

div[disabled='disabled'] .vpd-day-text {
  color: rgb(155, 153, 153) !important;
}
</style>
